import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function AssetProtectionPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['asset-protection']} />;
}
